import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const NotesTitle = styled.p(() =>
  mq({
    color: defaultTheme.text.gray,
    fontSize: defaultTheme.font.size.xs,
    fontWeight: 'bold',
  }),
);

export const NotesList = styled.ul(() =>
  mq({
    color: defaultTheme.text.gray,
    fontSize: defaultTheme.font.size.xs,
    lineHeight: defaultTheme.font.height.l,
    '& > li': {
      display: 'flex',
      marginTop: defaultTheme.spacing.xs,
      '&::before': {
        content: '"・"',
      },
      '& a': {
        fontWeight: 'bold',
      },
    },
  }),
);
